import { Button, Page, PageTitleWithButton } from '../../../../../components';

import { Add } from '@mui/icons-material';
import { FWTListManagement } from './list-management-list';
import { useState } from 'react';

export const ListManagementPage = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  return (
    <Page title="Field Walkthrough Locations">
      <PageTitleWithButton
        pageTitleProps={{
          title: 'Field Walkthrough Locations'
        }}
        button={
          <Button
            id="create-client"
            onClick={() => {
              setIsAddModalOpen(true);
            }}
            color="primary"
            variant="contained"
            startIcon={<Add />}
          >
            Create Location
          </Button>
        }
      />
      <FWTListManagement isAddModalOpen={isAddModalOpen} setIsAddModalOpen={setIsAddModalOpen} />
    </Page>
  );
};
